<template>
    <div class="block-editor show-widget">
        <div class="wrapper">
            <section>
                <div class="title">User ID</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor v-model="clone.userId" automation-mode />
                </div>
            </section>
            <section>
                <div class="title">Title</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Type Title"
                        :show-attributes="true"
                        :show-emoji="true"
                        :max-character-count="1024"
                        v-model="clone.title"
                        automation-mode
                    />
                </div>
            </section>
            <section>
                <div class="title">URL</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor v-model="clone.url" automation-mode />
                </div>
            </section>
            <section>
                <div class="title">Full Screen Mode</div>
                <a-switch v-model="clone.fullScreen" />
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import { CHATBOT_API } from "../../../../../../api/chatbotv2";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../components/pickers/CustomPicker.vue";
import { mapState } from "vuex";

const log = log2("Showwidget");
export default {
    name: "Showwidget",
    components: { TiptapEditor, CustomPicker },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({}),
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
    async created() {
    },
};
</script>

<style lang="scss">
.block-editor.show-widget {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .form-picker-wrapper {
            background: white;
            border-radius: 0px;
            border: 1px solid #fff;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>
